// extracted by mini-css-extract-plugin
module.exports = {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__qP6LA","subTitleBold":"BoxSubTitle_subTitleBold__155oj"};